module.exports = __webpack_public_path__ + "6f8af20877124a756098decff4da8be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/blog-post/arrow-blog.png
// module id = ./src/components/blog-post/arrow-blog.png
// module chunks = index